<template>
  <div v-if="(printData.requestOwnerInfo || {}).requestCode">
    <row v-if="printData.requestOwnerInfo">
      <column full-width>
        <block>
          <papers-table
            :headers="[
              {
                value: 'requestCode',
                text: 'رقم الطلب',
              },
              {
                value: 'requesterName',
                text: 'مقدم الطلب',
              },
              {
                value: 'socialId',
                text: 'رقم الهوية',
              },
              {
                value: 'requestDate',
                text: 'تاريخ الطلب',
              },
            ]"
            :items="[printData.requestOwnerInfo]"
          ></papers-table>
        </block>
      </column>
    </row>

    <row v-if="printData.prosecutorRequestParties">
      <column full-width>
        <block title="بيانات المدعين">
          <papers-table
            :headers="[
              {
                value: 'partyType',
                text: 'النوع',
              },
              {
                value: 'partyName',
                text: 'الاسم',
              },
              {
                value: 'socialId',
                text: 'رقم الإثبات',
              },
              {
                value: 'representativeName',
                text: 'اسم الممثل',
              },
            ]"
            :items="printData.prosecutorRequestParties"
          ></papers-table>
        </block>
      </column>
    </row>

    <row v-if="printData.defendantRequestParties">
      <column full-width>
        <block title="بيانات المدعى عليهم">
          <papers-table
            :headers="[
              {
                value: 'partyType',
                text: 'النوع',
              },
              {
                value: 'partyName',
                text: 'الاسم',
              },
              {
                value: 'socialId',
                text: 'رقم الإثبات',
              },
              {
                value: 'representativeName',
                text: 'اسم الممثل',
              },
            ]"
            :items="printData.defendantRequestParties"
          ></papers-table>
        </block>
      </column>
    </row>

    <row v-if="printData.caseInfo">
      <column full-width>
        <block title="بيانات الدعوى">
          <papers-table
            vertical
            :headers="[
              {
                value: 'caseTypeName',
                text: 'نوع الدعوى',
              },
              {
                value: 'subject',
                text: 'موضوع الدعوى',
              },
              {
                value: 'demands',
                text: 'الطلبات',
              },
              {
                value: 'proofs',
                text: 'الأسانيد',
              },
            ]"
            :items="[printData.caseInfo]"
          ></papers-table>
        </block>
      </column>
    </row>
  </div>
  <div
    v-else
    class="status-box"
  >
    <div class="status-line">
      <v-icon
        color="primary"
        style="font-size: 45px; margin-left: 10px;"
      >
        mdi-information
      </v-icon>
      <div
        style="font-size: 32px;"
        class="text-green-600 text-lg font-bold"
        v-html="message"
      />
    </div>
  </div>
</template>

<script>
import Row from '@/components/printing/row.vue';
import Column from '@/components/printing/column.vue';
import Block from '@/components/printing/block.vue';
import PapersTable from '@/components/printing/table.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  components: {
    PapersTable,
    Block,
    Row,
    Column,
  },
  props: ['requestObjectKey', 'forPartyAuthentications'],
  data() {
    return {
      printData: {},
      message: '',
    };
  },
  watch: {
    requestObjectKey: {
      immediate: true,
      handler(value) {
        if (value)
          this.getData(value, this.forPartyAuthentications);
      },
    },
  },
  methods: {
    ...mapActions(['getReviewTicket']),
    getData(requestObjectKey, forPartyAuthentications) {
      this.getReviewTicket({
        requestObjectKey,
        forPartyAuthentications,
      }).then((result) => {
        if (result.success) {
          this.printData = result.data;
          this.$emit('getData', this.printData);
        }
        else {
          this.message = result.message;
        }
      });
    },
  },
};
</script>

<style scoped>
.status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
}

.status-line {
  display: flex;
  align-items: center;
  gap: 10px; /* مسافة بين الأيقونة والنص */
}

.icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.text-green-600 {
  color: #2e7d32; /* أخضر */
}

.message {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>